import { ReactNode } from 'react'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material'

import { NETWORK_GROWTH_CHART_HEIGHT } from 'components/reports/Metrics/constants'

import { NetworkGrowthSeries } from '../types'
import { CumulativeMetricChart } from './CumulativeMetricChart'
import { LegendItem } from './LegendItem'
import { SummaryStat } from './SummaryStat'

interface Props {
  title: string
  summaryCaption: string
  yAxisLabel: string
  color: string
  icon?: ReactNode
  info?: string
  legendLabel?: string
  series?: NetworkGrowthSeries | null
  suggestedMax?: number
  loading?: boolean
}

export const CumulativeMetricCard = ({
  title,
  summaryCaption,
  yAxisLabel,
  color,
  icon,
  info,
  legendLabel,
  series,
  suggestedMax,
  loading,
}: Props) => (
  <Paper
    variant='outlined'
    sx={{ p: 2.5, height: '100%', borderRadius: 2, borderTop: `3px solid ${color}` }}>
    <Stack direction='row' spacing={1} alignItems='center' mb={1.5}>
      {icon && <Box sx={{ color, display: 'flex' }}>{icon}</Box>}
      <Typography variant='subtitle1' fontWeight={600} sx={{ color }}>
        {title}
      </Typography>
      {info && (
        <Tooltip title={info}>
          <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
        </Tooltip>
      )}
    </Stack>

    <Box mb={1.5}>
      <SummaryStat
        value={(series?.summaryCount ?? 0).toLocaleString()}
        caption={summaryCaption}
        loading={loading}
      />
    </Box>

    {loading ? (
      <Skeleton
        variant='rectangular'
        height={NETWORK_GROWTH_CHART_HEIGHT}
        sx={{ borderRadius: 1 }}
      />
    ) : (
      <>
        <CumulativeMetricChart
          daily={series?.daily ?? []}
          color={color}
          yAxisLabel={yAxisLabel}
          suggestedMax={suggestedMax}
        />

        <Stack direction='row' spacing={2} mt={1} justifyContent='center'>
          <LegendItem label={legendLabel ?? yAxisLabel} swatch='line' color={color} />
        </Stack>
      </>
    )}
  </Paper>
)
